import React from 'react';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import { services } from '../../data/mockData';
import { useLanguage } from '../../context/LanguageContext';
import { FileText, ShieldCheck, Landmark, Hammer, ArrowUpRight } from 'lucide-react';

const iconMap = { FileText, ShieldCheck, Landmark, Hammer };

export default function ServicesSection() {
  const { t, tl } = useLanguage();
  const [sectionRef, isVisible] = useScrollReveal({ threshold: 0.1 });

  return (
    <section id="services" className="py-16 sm:py-24 lg:py-32 bg-[#0a0a0c]">
      <div ref={sectionRef} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 animate-reveal ${isVisible ? 'visible' : ''}`}>
        <div className="flex items-center gap-4 mb-6">
          <span className="text-[#c9a96e] text-xs font-semibold tracking-[0.25em] uppercase">{t('services_label')}</span>
          <div className="h-px flex-1 bg-[#2a2a30]" />
        </div>

        <div className="max-w-2xl mb-10 sm:mb-16">
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-[#f0ebe3] leading-tight">
            {t('services_h2_1')}
            <span className="text-gold-gradient block mt-1">{t('services_h2_2')}</span>
          </h2>
          <p className="text-[#8a857e] text-sm sm:text-base lg:text-lg leading-relaxed mt-4 sm:mt-6">{t('services_sub')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          {services.map((service, i) => {
            const Icon = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className={`group relative p-6 sm:p-8 lg:p-10 border border-[#1e1e24] rounded-xl bg-[#111114]/60 service-card gold-glow animate-reveal ${isVisible ? 'visible' : ''}`}
                style={{ transitionDelay: `${0.1 + i * 0.1}s` }}
              >
                <span className="absolute top-6 sm:top-8 right-6 sm:right-8 text-[#1e1e24] font-heading text-4xl sm:text-6xl font-bold leading-none select-none">{service.number}</span>
                <div className="relative z-10 w-12 h-12 sm:w-14 sm:h-14 rounded-lg bg-[#c9a96e]/10 flex items-center justify-center mb-5 sm:mb-6 group-hover:bg-[#c9a96e]/15" style={{ transition: 'background-color 0.4s ease' }}>
                  {Icon && <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-[#c9a96e]" />}
                </div>
                <div className="relative z-10">
                  <div className="flex items-center gap-3 mb-2">
                    <h3 className="text-[#f0ebe3] font-heading text-lg sm:text-xl font-semibold">{tl(service.title)}</h3>
                    <ArrowUpRight className="w-4 h-4 text-[#c9a96e] opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0" style={{ transition: 'opacity 0.3s ease, transform 0.3s ease' }} />
                  </div>
                  <p className="text-[#8a857e] text-xs sm:text-sm leading-relaxed mt-3">{tl(service.description)}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
